import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Paper, Tab, Tabs, Box, Typography, AppBar, Fade } from '@material-ui/core'
import DonutChart from '../charts/DonutChart'
import BarChart from '../charts/BarChart'

// import moment from 'moment'

// const today = moment().format('YYYY-MM-DD')
// const twelveMonths = moment().subtract(12, 'months').format('YYYY-MM-DD')
// console.log(today, twelveMonths)

function TabPanel(props) {
  const { children, value, index, ...other} = props

  return(
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  )
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  }
}

const useStyles = makeStyles((theme) =>
createStyles({
  root: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
    alignItems: 'stretch'
  },
  appBar: {
    background: '#fff',
    boxShadow: 'none',
    width: '100%'
  },
  indicator: {
    backgroundColor: 'transparent'
  },
  button: {
    backgroundColor: 'rgba(137, 67, 187, 1.0)',
    '&:hover': {
      backgroundColor: 'rgba(137, 67, 187, 0.5)'
    },
  },
  container: {
    height: 450,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  title: {
    padding: '1em',
    textAlign: 'center'
  },
  chart: {
    flexGrow: 6,
    [theme.breakpoints.down('sm')]: {
      marginTop: 45,
    }
  },
}))

function RoiCharts(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = ( event, newValue) => {
    // console.log(event, newValue)
    setValue(newValue)
  }

  return(
    <div className={classes.root}>
      <div>
      <Fade in={true} timeout={500}>
        <Paper square={true}>
          <AppBar position="static" className={classes.appBar} square={false}>
            <Tabs
              value={value}
              onChange={handleChange}
              classes={{indicator: classes.indicator}}
              textColor="inherit"
              centered
              variant="fullWidth"
              style={{borderTopRightRadius: 4, borderTopLeftRadius: 4}}
            >
              <Tab className={classes.button} label="Cost of Advertising" {...a11yProps(0)} disableRipple />
              <Tab className={classes.button} label="Responses: Customers vs Prospects" {...a11yProps(1)} disableRipple />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <div className={classes.container} style={{paddingTop: 30}}>
              <DonutChart
                data={[Math.round(props.chartsData[0].total.Cost), Math.round((props.chartsData[0].total.Sales / (props.chartsData[0].total.Responses / props.chartsData[0].total.Mailed)) * ((props.chartsData[0].total.Responses / props.chartsData[0].total.Mailed) - (props.chartsData[0].total.HO_Resp / props.chartsData[0].total.HO_Count)))]}
                total={true}
                totalLabel={'Incremental Sales'}
                totalData={Math.round((props.chartsData[0].total.Sales / (props.chartsData[0].total.Responses / props.chartsData[0].total.Mailed)) * ((props.chartsData[0].total.Responses / props.chartsData[0].total.Mailed) - (props.chartsData[0].total.HO_Resp / props.chartsData[0].total.HO_Count)))}
                // totalData={Math.round(props.chartsData[0].ADJ_Sales)}
                totalColor={'rgba(96, 219, 11, 0.9)'}
                radius={'65%'}
                labels={props.labels ? props.labels : []}
                legend={true}
                position={'bottom'}
                labelShow={true}
                colors={['rgba(255, 150, 8, 0.9)', 'rgba(96, 219, 11, 0.9)']}
                hoverColor={['rgba(247, 161, 224, 0.05)', 'rgba(109, 222, 128, 0.05)']}
                hoverBorderWidth={5}
                height={400}
                className={classes.chart}
                darkMode={props.darkMode}
              />
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <div className={classes.container} style={{paddingTop: 30}}>
              <DonutChart
                data={props.chartsData2.map(item => item.total.Responses)}
                total={false}
                radius={'65%'}
                labels={props.labels2 ? props.labels2 : []}
                legend={true}
                position={'bottom'}
                labelShow={true}
                colors={['rgba(199, 29, 20, 0.9)', 'rgba(18, 201, 235, 0.9)']}
                hoverColor={['rgba(125, 186, 255, 0.05)', 'rgba(255, 184, 84, 0.05)']}
                hoverBorderWidth={5}
                height={400}
                className={classes.chart}
                darkMode={props.darkMode}
              />
            </div>
          </TabPanel>
        </Paper>
      </Fade>
      </div>
      <div style={{paddingLeft: '25px'}} className={classes.chart}>
        <Fade in={true} timeout={500}>
          <AppBar position="static" className={classes.appBar} style={{background: '#8943bb', borderRadius: 4}}>
            <Typography className={classes.title} style={{fontSize: '17px'}}>
              WEEKLY INCREMENTAL SALES
              <br/>
            </Typography>
            <Paper className={classes.container} style={{position: 'relative', padding: '40px 15px 0px 15px', minHeight: '450px'}}>
              <BarChart
                labels={props.weeklydata.map(item => item.label)}
                data={[{
                  name: '',
                  data: props.weeklydata.map(item => (item.total.Responses / item.total.Mailed) - (item.total.HO_Resp / item.total.HO_Count) > 0 ? Math.round((item.total.Sales / (item.total.Responses / item.total.Mailed)) * ((item.total.Responses / item.total.Mailed) - (item.total.HO_Resp / item.total.HO_Count))) : 0)
                  // data: props.weeklydata.map(item => Math.round(item.ADJ_Sales))
                }]}
                horizontal={false}
                distributed={true}
                height={350}
                rotate={-65}
                colors={["#15d6c0"]}
                style={{margin: '1em'}}
                name={'Inc Sales'}
                rowColors={props.darkMode ? ['#2a2a2a', '#3a3a3a'] : ['#fff', '#f2f2f2']}
                darkMode={props.darkMode}
              />
            </Paper>
          </AppBar>
        </Fade>
      </div>
    </div>
  )
}

export default RoiCharts
